import { atom } from 'recoil'

export const SearchState = atom({
  key: 'search', // unique ID (with respect to other atoms/selectors)
  default: {
    questionNo: '',
    candidateCode: '',
    status: '',
    mandatoryCheck: '',
  },
})
